import Api from "../Repository.js"

const resource = `/search`;

export default {

  get_by_content_type_id(params) {
    return Api.get(`${resource}/by-content-type-id/`, { params: params })
  },
  get_by_model_path(params) {
    return Api.get(`${resource}/by-model-path/`, { params: params })
  },
}
